export default __webpack_public_path__ + "static/media/07.890e7abf.png";